export function transferRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_TRANSFER_START":           
        case "FETCH_TRANSFERS_START":                                 
        case "UPDATE_TRANSFER_START":                                 
        case "DELETE_TRANSFER_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_TRANSFER_FULFILLED":           
        case "FETCH_TRANSFERS_FULFILLED":                                 
        case "UPDATE_TRANSFER_FULFILLED":                                 
        case "DELETE_TRANSFER_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_TRANSFER_ERROR":
        case "FETCH_TRANSFERS_ERROR":
        case "UPDATE_TRANSFER_ERROR":
        case "DELETE_TRANSFER_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}